module.exports = __webpack_public_path__ + "media/images/common/logo_privacy-75cff77d379da836fe92f31e86910c9e.png";